import moment from 'moment';

import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions

const GET_CUSTOMERS = 'luft/customer/GET_CUSTOMERS';
const GET_CUSTOMERS_SUCCESS = 'luft/customer/GET_CUSTOMERS_SUCCESS';
const GET_CUSTOMERS_FAILURE = 'luft/customer/GET_CUSTOMERS_FAILURE';

// reducer

const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  list: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_CUSTOMERS:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list,
      };

    case GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getCustomers() {
  return { type: GET_CUSTOMERS };
}

function _getCustomersSuccess(list) {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    list,
  };
}

function _getCustomersFailure(error) {
  return {
    type: GET_CUSTOMERS_FAILURE,
    error,
  };
}

// thunk action creators

export function getCustomers(query) {
  return function (dispatch) {
    (async () => {
      dispatch(_getCustomers());

      const params = {};

      if (query) {
        params.query = query;
      }

      try {
        const response = await luftGet(
          '/Customer/GetClientsByCompanyId',
          params,
        );
        dispatch(_getCustomersSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getCustomersFailure(error.message),
        );
      }
    })();
  };
}
